import React from 'react';
import { Modal, Form } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import FormErrorCode from './FormErrorCode';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';
import { fetchAddErrorCode } from '../../../../store/ErrorCodeSlice';

const AddErrorCode: React.FC<any> = (props) => {
  const { handleAddModal, openAddModal, getList } = props;

  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();

  const handleSubmit = (data: any) => {
      dispatch(fetchAddErrorCode(data))
      .then(() => {
        handleAddModal();
        getList();
      })
      .catch(() => {
        handleAddModal();
      });
  };
  return (
    <>
      <Modal
        open={openAddModal}
        destroyOnClose
        width={800}
        onCancel={handleAddModal}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className="addModal"
        title={`Add Error Code`}
      >
        <FormErrorCode
          form={form}
          handleAddErrorCode={handleSubmit}
        />
      </Modal>
    </>
  );
};

export default AddErrorCode;
